import React from 'react';
export function HeroSection() {
  return <section className="w-full bg-white pt-16 md:pt-20 pb-12 md:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-88" data-mp="32hrs3zcn4kfo">
      <div className="max-w-4xl mx-auto" data-id="element-89" data-mp="2hwdx3arjl3xr">
        <div className="md:float-right md:ml-12 md:mb-8 md:w-72 mb-0 hidden md:block" data-id="element-90" data-mp="23vbamwwmxrmb">
          <img src="https://cdn.magicpatterns.com/uploads/hF76dzehUfzLdMiLFA7oGP/Headshot_1.jpg" alt="Michael Hirsch" className="w-full aspect-[4/5] object-cover object-center rounded-lg shadow-sm" data-id="element-91" data-mp="28u4q2uvhfsp4" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-navy leading-tight mb-6" data-id="element-92" data-mp="30kspo2hicq0o">
          <span className="block" data-id="element-93" data-mp="2mte4bp04ocqg">
            <em data-id="element-94" data-mp="2rt0ka67cc72y">Individuals</em> on your team are using AI.
          </span>
          <span className="block mt-3" data-id="element-95" data-mp="2rr5uoel4jqsj">
            Your <em data-id="element-96" data-mp="3fi1k5523y9wm">team</em> isn't.
          </span>
        </h1>
        <div className="space-y-4 text-lg md:text-xl text-brand-gray leading-relaxed mb-8" data-id="element-97" data-mp="3fgi51hs6u4wf">
          <p data-id="element-98" data-mp="3kbe8de2vkeou">
            Some are going deep. Others tried it once and stopped. A few are
            sending AI outputs straight to clients without a second look. And
            you're the one who has to answer for all of it.
          </p>
          <p data-id="element-99" data-mp="2p5v6men6gh9w">
            MIT found that 95% of enterprise AI pilots fail to deliver
            measurable results. The problem isn't the technology. It's that
            most teams have no plan for how to use it together.
          </p>
          <p className="font-bold text-brand-navy" data-id="element-100" data-mp="2z1y77g2ds7uq">I help leaders fix that.</p>
        </div>
        <div className="mb-8" data-id="element-101" data-mp="2u3mzbavnc7f5">
          <a href="https://scheduler.zoom.us/breakapencil/intro-call-30" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors shadow-sm" data-id="element-102" data-mp="2u6r7skg59pbm">
            Book a Call
          </a>
        </div>
        <div className="md:hidden" data-id="element-103" data-mp="38tl13h93ahuq">
          <img src="https://cdn.magicpatterns.com/uploads/hF76dzehUfzLdMiLFA7oGP/Headshot_1.jpg" alt="Michael Hirsch" className="w-full max-w-xs aspect-[4/5] object-cover object-center rounded-lg shadow-sm" data-id="element-104" data-mp="38umn2grn8or8" />
        </div>
      </div>
    </section>;
}